import React from "react";
import { useAuth } from "../contexts/AuthContext";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress,
} from "@mui/material";
import { useUserFavorites } from "../hooks/useUserFavorites";
import FavoritesComponent from "../components/FavoritesComponent";
import { Link } from "react-router-dom";

const FavoriteList = () => {
  const { userId, authToken, isAuthenticated } = useAuth();
  const { data: favoritesPlaces = [], isLoading, error, refetch } = useUserFavorites(userId);

  // Transform favorites places array to match the table structure
  // The API returns Place[] with dateAdded property preserved
  const favorites = favoritesPlaces.map((place) => ({
    _id: place._id,
    placeId: place, // The place itself
    dateAdded: place.dateAdded || new Date().toISOString(),
  }));

  return (
    <Box sx={{ px: 5, pt: 2 }}>
      <Typography variant="h4">Favorites</Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Place Name</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Date Added</TableCell>
              <TableCell>Actions</TableCell>
              <TableCell>View</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                    <CircularProgress />
                  </Box>
                </TableCell>
              </TableRow>
            ) : error ? (
              <TableRow>
                <TableCell colSpan={5}>
                  <Alert severity="error">
                    Error loading favorites. Please try again.
                  </Alert>
                </TableCell>
              </TableRow>
            ) : favorites.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5}>No favorites added yet.</TableCell>
              </TableRow>
            ) : (
              favorites.map((favorite) => (
                <TableRow key={favorite._id}>
                  <TableCell>{favorite.placeId.name}</TableCell>
                  <TableCell>{favorite.placeId.type}</TableCell>
                  <TableCell>
                    {new Date(favorite.dateAdded).toLocaleDateString()}
                  </TableCell>
                  <TableCell>
                    <FavoritesComponent
                      placeId={favorite.placeId._id}
                      isAuthenticated={isAuthenticated}
                      userId={userId}
                      authToken={authToken}
                      favorites={favoritesPlaces}
                      onUpdateFavorites={refetch}
                    />
                  </TableCell>
                  <TableCell>
                    <Button
                      component={Link}
                      to={`/places/${favorite.placeId._id}`}
                      color="primary"
                    >
                      View
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default FavoriteList;
